import AuthService from "services/auth.service";
import useChannel from "hooks/useChannel";
import { useDispatch } from "react-redux";
import { showIncomingRequestModal } from "app/ondemandSlice";

export function OndemandSocket() {
  const dispatch = useDispatch();
  const currentUser = AuthService.getCurrentUser();
  const { isAssistant, chanelId } = AuthService.getSocketInfo();

  // Same guard as before: doctors only, nutritionists excluded.
  const enabled =
    currentUser?.user_type === "doctor" &&
    currentUser?.is_bookdoc_nutritionist !== true;

  let channelParams = null;
  if (enabled) {
    channelParams = isAssistant
      ? chanelId
        ? { channel: "TeleconsultOnDemandChannel", doctor_id: chanelId }
        : null
      : { channel: "TeleconsultOnDemandChannel" };
  }

  useChannel(channelParams, {
    connected: (subscription) => {
      subscription.perform("status");
    },

    received: (data) => {
      if (data) {
        dispatch(showIncomingRequestModal(data));
      }
    },
  });

  return null;
}

export default OndemandSocket;
